var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"flex items-center flex-col lg:flex-row lg:p-4 shrink-0 lg:py-3 bg-white border",class:[
        _vm.tourClass
    ],on:{"click":function($event){$event.preventDefault();return _vm.$emit('selected')}}},[(_vm.type)?[_c('div',{class:[
                _vm.type.includes('color') ? 'rounded-full border border-black': `menu-item-${(_vm.type || 'none')}`,
                _vm.type.includes('individual') && 'rounded-full ml-0.5 mr-3.5',
                'h-8 w-8 mr-4',
                { 'border border-gray-300': _vm.selected },
            ],style:([_vm.type.includes('color') && {backgroundColor: _vm.selectedColorHex}])},[_c('span')])]:_vm._e(),_c('div',{staticClass:"flex items-center justify-center w-20 mx-4 lg:mx-0 lg:w-auto uppercase font-bold text-lg"},[_c('div',{staticClass:"text-base whitespace-pre-wrap lg:text-xl"},[_vm._v(" "+_vm._s(_vm.title)+" ")])])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }